'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0, // 禁用默认缓存，总是获取最新数据
            refetchOnWindowFocus: true, // 窗口聚焦时重新获取
            refetchOnMount: true, // 组件挂载时重新获取
            retry: 1, // 只重试1次
            retryDelay: 1000, // 重试延迟1秒
            // 即使查询失败也继续渲染
            throwOnError: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}

